export default __webpack_public_path__ + "static/about-leadership-image-e4cfb94eb3356f5de91f65f66435f29e.webp";